


import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BrandHeader from "./BrandHeader";
import MultipleInvitesModal from './multipleinviteinfluencers';
import Navbar from "./Navbar";

const MessageBox = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const usersPerPage = 7;
  const maxSelectionLimit = 20;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://server-side-influencer.onrender.com/brand/getallinfluenecers');
        const data = await response.json();
        if (data.success) {
          setUsers(data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 790);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMessageBoxClick = (user, event) => {
    if (event.target.type === 'checkbox' || event.target.innerText === 'View') return;
    navigate('/infldetails', { state: { userData: user } });
  };

  const handleCheckboxChange = (userId) => {
    const isSelected = selectedUsers.includes(userId);

    if (isSelected) {
      setSelectedUsers(selectedUsers.filter(id => id !== userId));
    } else {
      if (selectedUsers.length < maxSelectionLimit) {
        setSelectedUsers([...selectedUsers, userId]);
      } else {
        toast.error(`You can only select up to ${maxSelectionLimit} users at a time!`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    }
  };

  const filteredUsers = users.filter(user =>
    user.fullname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleInviteClick = () => {
    if (selectedUsers.length > 0) {
      setIsModalOpen(true);
    } else {
      toast.warning('Please select some influencers first!');
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    // kkk
    <div className="flex h-screen mb-0">
      <div className="text-white fixed top-0 left-0 bottom-0 z-10">
        <Navbar />
      </div>

       <div className="w-screen max-sm:ml-0 h-screen" style={{ marginLeft: isSmallScreen ? '1px' : '20px', marginTop: isSmallScreen ? '20px' : '2px'}}>
        <ToastContainer />
        <BrandHeader page="Invite" />

        <div className="text-center mb-8 sm:mb-4" style={{ position: 'relative' }}>
          {users.length > 0 && (
        <button
          onClick={handleInviteClick}
          className="absolute top-[170%] right-[67px] transform translate-y-[-50%] px-6 py-3 text-sm bg-gradient-to-br from-purple-600 to-blue-500 text-white rounded-lg shadow-lg hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800"
          style={{ zIndex: 5 }}  
        >
          Invite
        </button>
          )}

          {/* <h1 className="text-xs sm:text-sm lg:text-lg font-bold text-black uppercase tracking-wide py-5 px-0 sm:px-4 ml-[50px]">
            Start Building Your Brand Campaign and Invite Influencers for Maximum Impact!
          </h1> */}

<h1 className="text-xs sm:text-sm md:text-base lg:text-3xl font-bold text-black uppercase tracking-wide py-5 px-0 sm:px-4 ml-[50px]  mt-12">
  Start Building Your Brand Campaign and Invite Influencers for Maximum Impact!
</h1>


          <div className="mb-4 w-full max-w-md mx-auto mt-4">
            <input
              type="text"
              placeholder="Search Influencers"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>

        {loading ? (
          <div style={{ marginTop: '140px', marginLeft: isSmallScreen ? '35px' : '90px' }}>
            {[...Array(usersPerPage)].map((_, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  padding: '10px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  alignItems: 'center',
                  cursor: 'pointer',
                  marginBottom: '15px',
                  marginLeft: isSmallScreen ? '0px' : '55px',
                  width: isSmallScreen ? '90%' : '70%',
                }}
              >
                <div style={{ position: 'absolute', left: '-35px', top: '50%', transform: 'translateY(-50%)' }}>
                  <Skeleton width={18} height={18} />
                </div>
                <div style={{ marginRight: '15px' }}>
                  <Skeleton circle width={40} height={40} />
                </div>
                <div style={{ flex: 1 }}>
                  <Skeleton width="60%" height={20} />
                  <Skeleton width="40%" height={14} style={{ marginTop: '6px' }} />
                </div>
              </div>
            ))}
          </div>
        ) : filteredUsers.length === 0 ? (
          <div style={{ textAlign: 'center', fontSize: '16px', color: '#888' }}>
            <p>No influencers found</p>
          </div>
        ) : (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                marginTop: '140px',
                marginLeft: isSmallScreen ? '2px' : '30px',
              }}
            >
              {currentUsers.map((user, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '10px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    position: 'relative',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginLeft: isSmallScreen ? '35px' : '90px',
                  }}
                  onClick={(event) => handleMessageBoxClick(user, event)}
                >
                  <div style={{ position: 'absolute', left: '-35px', top: '50%', transform: 'translateY(-50%)' }}>
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(user._id)}
                      onChange={() => handleCheckboxChange(user._id)}
                      style={{
                        appearance: 'none',
                        width: '18px',
                        height: '18px',
                        border: '1px solid blue',
                        borderRadius: '4px',
                        position: 'relative',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        backgroundColor: selectedUsers.includes(user._id) ? '#007bff' : 'transparent',
                      }}
                    />
                    {selectedUsers.includes(user._id) && (
                      <span
                        style={{
                          position: 'absolute',
                          top: '2px',
                          left: '4px',
                          fontSize: '14px',
                          color: 'white',
                        }}
                      >
                        ✔
                      </span>
                    )}
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                    <img
                      src={user.profilepicinfluet || 'https://i.postimg.cc/Dz1BGyyP/profile5.png'}
                      alt={user.fullname}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                      }}
                    />
                    <span style={{ fontSize: '16px', fontWeight: '600', marginLeft: '10px' }}>
                      {user.fullname || 'No Name Provided'}
                    </span>
                  </div>

                  <button
                    onClick={() => navigate('/infldetails', { state: { userData: user } })}
                    className="ml-auto px-4 py-2 text-sm bg-gradient-to-br from-purple-600 to-blue-500 text-white rounded-lg shadow-lg hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800"
                  >
                    View
                  </button>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                style={{ marginRight: '5px', padding: '5px 10px' }}
              >
                Previous
              </button>

              {[...Array(totalPages).keys()].map((number) => (
                <button
                  key={number}
                  onClick={() => paginate(number + 1)}
                  style={{
                    margin: '0 5px',
                    padding: '5px 10px',
                    backgroundColor: currentPage === number + 1 ? '#007bff' : 'transparent',
                    color: currentPage === number + 1 ? '#fff' : '#000',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                  }}
                >
                  {number + 1}
                </button>
              ))}

              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{ marginLeft: '5px', padding: '5px 10px' }}
              >
                Next
              </button>
            </div>
          </>
        )}

        {isModalOpen && <MultipleInvitesModal selectedUsers={selectedUsers} onClose={handleCloseModal} />}
      </div>
    </div>
  );
};

export default MessageBox;
